<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { defineProps, toRefs } from "vue";
    import { SIDOR } from "@/tabs/Operation/utils";

    const props = withDefaults(
        defineProps<{
            name?: string;
            label?: string;
        }>(),
        {
            name: "sida",
            label: "Sida",
        }
    );

    const { name, label } = toRefs(props);
</script>

<template>
    <KAutocomplete
        :name="name"
        :label="label"
        v-bind="$attrs"
        :options="SIDOR"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
